var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuestionFull = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM4.92857 4.5C4.92857 3.90826 5.40826 3.42857 6 3.42857C6.59174 3.42857 7.07143 3.90826 7.07143 4.5C7.07143 5.09174 6.59174 5.57143 6 5.57143C5.64496 5.57143 5.35714 5.85925 5.35714 6.21429V6.76841C5.35714 7.12346 5.64496 7.41127 6 7.41127C6.35504 7.41127 6.64286 7.12346 6.64286 6.76841C7.63221 6.48859 8.35714 5.57895 8.35714 4.5C8.35714 3.19819 7.30181 2.14286 6 2.14286C4.69819 2.14286 3.64286 3.19819 3.64286 4.5C3.64286 4.85504 3.93068 5.14286 4.28571 5.14286C4.64075 5.14286 4.92857 4.85504 4.92857 4.5ZM6.85714 9C6.85714 9.4734 6.47339 9.85714 6 9.85714C5.52661 9.85714 5.14286 9.4734 5.14286 9C5.14286 8.52661 5.52661 8.14286 6 8.14286C6.47339 8.14286 6.85714 8.52661 6.85714 9Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionFull);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/QuestionFull.4ec48a92654438478b3efb607b894601.svg";